import React from 'react';
import { Briefcase, Shield, Users, Target } from 'lucide-react';
export function TimelineSection() {
  const timelineItems = [{
    icon: <Briefcase className="h-6 w-6 text-white" data-id="element-192" />,
    color: 'bg-blue-600',
    title: 'Founder & CEO, FiQIS',
    subtitle: 'Current Role',
    description: 'Leading the development of next-generation financial infrastructure. Architecting modular banking systems designed to replace outdated legacy technology with scalable, secure solutions.'
  }, {
    icon: <Shield className="h-6 w-6 text-white" data-id="element-193" />,
    color: 'bg-slate-800',
    title: 'Post-Quantum Security Focus',
    subtitle: 'Core Initiative',
    description: 'Pioneering the integration of post-quantum encryption into core banking infrastructure before launch, ensuring financial systems are prepared for future cryptographic threats.'
  }, {
    icon: <Target className="h-6 w-6 text-white" data-id="element-194" />,
    color: 'bg-blue-500',
    title: 'Building Smarter Credit',
    subtitle: 'Product Vision',
    description: 'Moving beyond traditional BNPL (Buy Now, Pay Later) models to build smarter, more resilient credit systems that benefit both institutions and end consumers.'
  }, {
    icon: <Users className="h-6 w-6 text-white" data-id="element-195" />,
    color: 'bg-slate-600',
    title: 'Servant Leadership & Ethics',
    subtitle: 'Leadership Philosophy',
    description: 'Fostering a culture of ethical innovation. Balancing rapid AI and security advancements with a steadfast commitment to human impact, transparency, and stakeholder engagement.'
  }];
  return <section id="experience" className="py-24 bg-[#0d1321] px-4 sm:px-6 lg:px-8" data-id="element-196">
      <div className="max-w-4xl mx-auto" data-id="element-197">
        <div className="text-center mb-16" data-id="element-198">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-199">
            Career & Leadership Focus
          </h2>
          <div className="w-20 h-1 bg-gradient-to-r from-cyan-400 to-blue-500 mx-auto rounded-full mb-6" data-id="element-200"></div>
          <p className="text-lg text-slate-400" data-id="element-201">
            Key pillars driving the vision and execution at FiQIS.
          </p>
        </div>

        <div className="relative" data-id="element-202">
          {/* Vertical Line */}
          <div className="absolute left-4 md:left-1/2 transform md:-translate-x-1/2 top-0 bottom-0 w-0.5 bg-white/10" data-id="element-203"></div>

          <div className="space-y-12" data-id="element-204">
            {timelineItems.map((item, index) => <div key={index} className={`relative flex flex-col md:flex-row items-start ${index % 2 === 0 ? 'md:flex-row-reverse' : ''}`} data-id="element-205">
                {/* Center Icon */}
                <div className="absolute left-4 md:left-1/2 transform -translate-x-1/2 flex items-center justify-center w-12 h-12 rounded-full border-4 border-[#0d1321] z-10 shadow-sm mt-1 md:mt-0" style={{
              backgroundColor: '#22D3EE' /* cyan-400 */
            }} data-id="element-206">
                  <div className={`w-full h-full rounded-full flex items-center justify-center bg-[#0B1120]`} data-id="element-207">
                    {item.icon}
                  </div>
                </div>

                {/* Content Box */}
                <div className={`ml-16 md:ml-0 w-full md:w-1/2 ${index % 2 === 0 ? 'md:pl-12' : 'md:pr-12'}`} data-id="element-208">
                  <div className="bg-white/5 backdrop-blur-sm p-6 rounded-xl shadow-sm border border-white/10 hover:bg-white/10 transition-colors" data-id="element-209">
                    <span className="text-sm font-bold text-cyan-400 uppercase tracking-wider mb-1 block" data-id="element-210">
                      {item.subtitle}
                    </span>
                    <h3 className="text-xl font-bold text-white mb-3" data-id="element-211">
                      {item.title}
                    </h3>
                    <p className="text-slate-400 leading-relaxed" data-id="element-212">
                      {item.description}
                    </p>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}